<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item"><router-link to="/sale/orders">{{ $t('sale_order') }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{title}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <b-btn variant="outline-primary no-bor" size="sm" @click="save"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('customer') }}</label>
                                <div>
                                    <CustomerDropdown @select="customerSelected" :value="header.CustomerName"></CustomerDropdown>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <div class="form-group">
                                <label class="control-label">&nbsp;</label>
                                <div>
                                    <button type="button" class="btn btn-outline-info btn-sm" @click="$refs.copyquote.$refs.innermodal.show()">{{$t('copy_from_quote')}} <span v-if="header.RefNum!=undefined" class="red">({{header.RefNum}})</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group" :class="{ 'form-group-error': $v.header.Num.$error }">
                                <label class="control-label blue">{{ $t('order_no') }}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="$v.header.Num.$model" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <DatePicker v-model="date" :label="$t('order_date')"/>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th style="width: 30px;"></th>
                                        <th>{{$t('item_name')}}</th>
                                        <th>{{$t('description')}}</th>
                                        <th style="width: 100px;">{{$t('qty')}}</th>
                                        <th style="width: 120px;">{{$t('uom')}}</th>
                                        <th style="width: 100px;">{{$t('cost')}}</th>
                                        <th style="width: 100px;">{{$t('unit_price')}}</th>
                                        <th style="width: 100px;">{{$t('vat_per')}}</th>
                                        <th class="text-right" style="width: 100px;">{{$t('amount')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in lines" :key="ret.Id">
                                        <td style="width: 30px;">
                                            <button type="button" class="btn btn-danger btn-remove" @click="onRemove(index)">X</button>
                                        </td>
                                        <td><AuthCompleted @select="itemSelect($event, ret)" :value="ret.ItemName"></AuthCompleted></td>
                                        <td class="text-center">
                                            <input type="text" class="form-control form-control-sm" v-model="ret.Description" :disabled="ret.ItemId==''">
                                        </td>
                                        <td class="text-center">
                                            <input type="number" class="form-control form-control-sm" v-model="ret.Quantity" @keypress="$isKeyNumber" @change="reCalculate" :disabled="ret.ItemId==''">
                                        </td>
                                        <td>
                                            <template v-if="ret.IsMultipleUnit">
                                                <select class="form-control form-control-sm" v-model="ret.UomId" :disabled="ret.ItemId==''">
                                                    <option v-for="ret in ret.Uoms" :key="ret.Id" :value="ret.Id">{{ret.Name}}</option>
                                                </select>
                                            </template>
                                            <template v-else>
                                                <input type="text" class="form-control form-control-sm" v-model="ret.UomName" disabled>
                                            </template>
                                        </td>
                                        <td class="text-right">
                                            <input type="number" class="form-control form-control-sm" v-model="ret.Cost" :disabled="ret.ItemId==''" />
                                        </td>
                                        <td class="text-right">
                                            <input type="number" class="form-control form-control-sm" v-model="ret.Price" @keypress="$isKeyNumber" @change="reCalculate" :disabled="ret.ItemId==''">
                                        </td>
                                        <td class="text-right">
                                            <select class="form-control form-control-sm" v-model="ret.TaxLine" @change="reCalculate" :disabled="ret.ItemId==''">
                                                <option value="10">Yes</option>
                                                <option value="0">No</option>
                                            </select>
                                        </td>
                                        <td class="text-right">
                                            <input type="text" class="form-control form-control-sm text-right" :value="$money(ret.SubTotal)" readonly />
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="6" rowspan="3" style="vertical-align: top;">
                                            <div style="display: flex; gap: 8px; padding: 15px 0;">
                                                <button type="button" class="btn btn-outline-primary btn-sm" @click="addLine"><i class="fa fa-plus"></i> {{ $t('add_line') }}</button>
                                                <button type="button" class="btn btn-outline-primary btn-sm" @click="onClearLine"><i class="fa fa-times"></i> {{ $t('clear_all_line') }}</button>
                                            </div>
                                        </td>
                                        <th colspan="2" class="text-right">{{$t('grand_total')}}:</th>
                                        <th class="text-right">{{$money(header.GrandTotal)}}</th>

                                    </tr>
                                    <tr>
                                        <th colspan="2" class="text-right">{{$t('vat_dollar')}}:</th>
                                        <th class="text-right">{{$money(header.TaxVat)}}</th>
                                    </tr>
                                    <tr>
                                        <th colspan="2" class="text-right">{{$t('total')}}:</th>
                                        <th class="text-right">{{$money(header.PaidAmount)}}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <SelectAsModal ref="copyquote" :customer-id="header.CustomerId" @copy="onCopy"></SelectAsModal>
    </div>
</template>
<script>
import { AuthCompleted } from '../Item';
import { CustomerDropdown } from '../Customer';
import { required } from 'vuelidate/lib/validators';
import DatePicker from "../Components/DatePicker.vue";     
import SelectAsModal from './Quotes/SelectAsModal';
import Quote from '../../shared/models/Quote';
export default {
    components: {
        AuthCompleted,
        CustomerDropdown,
        SelectAsModal,
        DatePicker
    },
    data: function(){
        return {
            title: this.$t('sale_order_create'),
            header: {
                Num: '',
                CustomerId: '',
                CustomerName: '',
                Phone: '',
                GrandTotal: 0,
                TaxVat: 0,
                PaidAmount: 0
            },
            lines: [{
                ItemId: '',
                ItemName: '',
                Uoms: [],
                UomId: '',
                UomName: '',
                Quantity: 1,
                Cost: 0,
                Price: 0,
                Discount: 0,
                TaxLine: 0,
                SubTotal: 0
            }],
            date: this.$now().format('DD-MM-YYYY'),
        }
    },
    validations: {
        header: {
            Num: { required }
        }
    },
    created(){
        let id = this.$route.params.id;
        if(id != undefined && id != null && id != ''){
            let loading = this.$loading.show();
            this.$api().post('sale/order/find', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    let data = res.data.Json;
                    this.header = data.Header;
                    this.lines = data.Lines;
                    this.date = this.header.Date;
                    this.title = this.$t('sale_order_update') +' ['+ this.header.Num + ']';
                }
            }).finally(function(){ loading.hide(); });
        }
    },
    methods: {
        addLine(){
            this.lines.push({
                ItemId: '',
                ItemName: '',
                UomId: '',
                UomName: '',
                Quantity: 1,
                Price: 1,
                Discount: 0,
                TaxLine: 0,
                SubTotal: 1
            });
        },
        save(){
            if(this.lines.length > 0){
                this.$v.$touch();
                if(!this.$v.$invalid) {
                    let loading = this.$loading.show();
                    this.header.Date = this.date;
                    this.header.CompanyId = this.$store.state.company.Id;
                    this.header.ClientId = this.$store.state.company.ClientId;
                    var req = {
                        Header: this.header,
                        Lines: this.lines
                    };
                    this.$api().post('sale/order/save', req).then(res => {
                        if(this.$isValid(res)){
                            this.$router.push('/sale/orders');
                        }
                    }).finally(function() { loading.hide();});
                }
            }
        },
        customerSelected(evt){
            this.header.CustomerId = evt.data.Id;
            this.header.CustomerName = evt.data.Name;
        },
        reCalculate(){
            let grand_total = 0;
            let taxs = 0;
            let total = 0;
            let discount = 0;
            this.lines.map(item => {
                let grand = item.Quantity * item.Price;
                let dis = grand * (item.Discount / 100);
                let line_untax = grand - dis;
                let line_tax = line_untax * (item.TaxLine / 100);
                let line_sub = line_untax + line_tax;
                item.SubTotal = line_sub;
                grand_total += grand;
                discount += dis;
                taxs += line_tax;
                total += line_sub;
            });
            this.header.Discount = discount;
            this.header.GrandTotal = grand_total;
            this.header.TaxVat = taxs;
            this.header.PaidAmount = total;
        },
        itemSelect(evt, line){
            line.ItemId = evt.Id;
            line.ItemName = evt.Name;
            line.Price = evt.Price;
            line.Cost = evt.Cost;
            this.reCalculate();
        },
        onRemove(index){
            this.lines.splice(index, 1);
            this.reCalculate();
        },
        onClearLine(){
            this.lines  = [{
                ItemId: '',
                ItemName: '',
                UomId: '',
                UomName: '',
                Quantity: 1,
                Cost: 0,
                Price: 0,
                Discount: 0,
                TaxLine: 0,
                SubTotal: 0
            }];
            this.reCalculate();
        },
        uomChange(e, line){
            line.UomId = e.UomId;
            line.UomName = e.UomName;
            line.Price = e.Price;
            line.Cost = e.Cost;
            this.reCalculate();
        },
        async onCopy(id){
            let loading = this.$loading.show();
            try {
                var res = await Quote.toOrder(id);
                if(this.$isValid(res)){
                    var json = res.data.Json;
                    this.header = json.Header;
                    this.lines = json.Lines;
                    this.reCalculate();
                }
            } catch (error) {
                this.$Swal.fire('Warning Message', error.message, 'warning');
            }finally{ loading.hide(); this.$refs.copyquote.$refs.innermodal.hide(); }
        }
    }
}
</script>
<style scoped>
    .red{
        color:red;
    }
</style>
